import React, { useContext } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { setChatAlert } from 'models/twilio';
import { UserSessionContext } from 'components/UserSession';
import addContact from 'network/addContact';
import { addContactToRedux } from 'models/contacts';

import AddContactMessage from 'components/chat/AddContactMessage';
import useCurrentAttendee from 'components/twilio/hooks/useCurrentAttendee';

const useSendNameCard = () => {
  const { userSession } = useContext(UserSessionContext);
  const { exhibitorBoothId } = useCurrentAttendee();
  const dispatch = useDispatch();

  const handleAddToContact = async (contactId) => {
    if (!contactId) return;
    const userId = userSession?.rongcloudUserId;
    const response = await addContact(userId, contactId);
    const contact = response?.contact;
    if (exhibitorBoothId) {
      window.trackingItemToFirebase(userSession, 'Booth', 'Add_Contact', contact.uuid, contact.email, exhibitorBoothId, contact.name);
    }
    if (contact) {
      const id = contact?.uuid;
      const contactObj = {
        contact,
        id,
        createdAt: moment().utc().format('YYYY-MM-DD'),
      };
      dispatch(addContactToRedux(contactObj));
      dispatch(setChatAlert({ message: <AddContactMessage />, severity: 'success' }));
    }
  };
  return ({
    handleAddToContact,
  });
};

export default useSendNameCard;
